<template>
  <div class="order-picker" v-click-outside="doHideDropdown">
    <div class="dropdown" :class="{'show': showDropdown}">
      <button
        class="btn btn-primary btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded="false"
        ref="Dropdown"
        @click="doShowDropdown"
      >
       <!-- Sort -->
        <i class="fas fa-sort-amount-down-alt"></i>
        {{sortName}}
      </button>
      <div class="dropdown-menu" :class="{'show': showDropdown}">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4">
              <div class="head">{{$t('sort.tlt_distance')}}</div>
              <div
                class="selection-wraper"
                v-for="distance in values.distance"
                :key="distance.value"
              >
                <button
                  type="button"
                  class="btn"
                  :class="{'btn-outline-secondary': (model.distance !== distance.value), 'btn-primary': (model.distance === distance.value)}"
                  @click="setDistance(distance.value)"
                >{{distance.title}}</button>
              </div>
            </div>
            <div class="col-md-4">
              <div class="head">{{$t('sort.tlt_price')}}</div>
              <div class="selection-wraper" v-for="price in values.price" :key="price.value">
                <button
                  type="button"
                  class="btn"
                  :class="{'btn-outline-secondary': (model.price !== price.value), 'btn-primary': (model.price === price.value)}"
                  @click="setPrice(price.value)"
                >{{price.title}}</button>
              </div>
            </div>
            <div class="col-md-4">
              <div class="head">{{$t('sort.tlt_rating')}}</div>

              <div class="selection-wraper" v-for="rating in values.rating" :key="rating.value">
                <button
                  type="button"
                  class="btn"
                  :class="{'btn-outline-secondary': (model.rate !== rating.value), 'btn-primary': (model.rate === rating.value)}"
                  @click="setRating(rating.value)"
                >{{rating.title}}</button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <button type="button" class="btn btn-outline-secondary col-12" @click="resetAll">{{$t('sort.btn_reset')}}</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-info col-12" @click="apply">{{$t('sort.btn_apply')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.order-picker {
  display: inline-block;
}
.dropdown-menu {
  min-width: 600px;
  -webkit-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 2px 20px -10px rgba(0, 0, 0, 0.75);
  padding: 10px;
  .head {
    font-weight: bold;
    padding-bottom: 10px;
  }
  .selection-wraper {
    padding-bottom: 10px;
    button {
      font-size: 0.9em;
      font-weight: bold;
    }
  }
}
.selection-wraper {
  .btn.btn-outline-secondary {
    border-color: #f4f4f4;
  }
}
@media (max-width: 991.98px) {
  .dropdown-menu {
    position: fixed;
    top: 15px;
    left: 15px;
    bottom: 15px;
    right: 15px;
    min-width: 100px;
      .selection-wraper {
        padding-bottom: 5px;
      }
  }
}
</style>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "OrderPicker",
  directives: { ClickOutside },
  data() {
    console.log(this.value);
    var model = {
      distance: 0,
      price: 0,
      rate: 0
    };
    if (this.value) {
      model.distance = this.value.distance || model.distance;
      model.price = this.value.price || model.price;
      model.rate = this.value.rate || model.rate;
    }

    return {
      showDropdown: false,
      model,
      sortName: this.$t('sort.name'),
      values: {
        distance: [
          {
            value: 0,
            title: this.$t('sort.distance.auto')
          },
          {
            value: 1,
            title: this.$t('sort.distance.nearest')
          },
          {
            value: -1,
            title: this.$t('sort.distance.furthest')
          }
        ],
        price: [
          {
            value: 0,
            title: this.$t('sort.price.auto')
          },
          {
            // value: -1,
            value: 1,
            title: this.$t('sort.price.lowest_to')
          },
          {
            // value: 1,
            value: -1,
            title: this.$t('sort.price.highest_to')
          }
        ],
        rating: [
          {
            value: 0,
            title: this.$t('sort.rating.auto')
          },
          {
            // value: -1,
            value: 1,
            title: this.$t('sort.rating.lowest_to')
          },
          {
            // value: 1,
            value: -1,
            title: this.$t('sort.rating.highest_to')
          }
        ]
      }
    };
  },
  props: {
    value: Object
  },
  computed: {
  },
  methods: {
    doHideDropdown() {
      this.showDropdown = false;
    },
    doShowDropdown() {
      this.showDropdown = true;
    },
    resetAll() {
      this.model.distance = 0;
      this.model.price = 0;
      this.model.rate = 0;
      this.doHideDropdown();
      this.$emit("input", this.model);
      this.sortName = this.$t('sort.name');
    },
    apply() {
      this.doHideDropdown();
      this.$emit("input", this.model);
    },
    setSortName(value,option){
      if(this.model[option] != 0){
        option = option == "rate" ? "rating" : option; 
        let listSort = this.values[option];
        this.sortName = listSort.filter(item => item.value == value)[0].title;
      }else{
        this.sortName = this.$t('sort.name');
      }
    },
    setDistance(value) {
      this.model.distance = value;
      this.model.price = 0;
      this.model.rate = 0;
      this.setSortName(value, 'distance');
    },
    setPrice(value) {
      this.model.distance = 0;
      this.model.price = value;
      this.model.rate = 0;
      this.setSortName(value, 'price');
    },
    setRating(value) {
      this.model.distance = 0;
      this.model.price = 0;
      this.model.rate = value;
      this.setSortName(value, 'rate');
    }
  },
  mounted() {
    // const Dropdown = this.$refs.Dropdown;
    // $("body").on("click", function(e) {
    //   if (
    //     !$("li.dropdown.mega-dropdown").is(e.target) &&
    //     $("li.dropdown.mega-dropdown").has(e.target).length === 0 &&
    //     $(".open").has(e.target).length === 0
    //   ) {
    //     $("li.dropdown.mega-dropdown").removeClass("open");
    //   }
    // });
  }
};
</script>